import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useEffect, useState } from 'react';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { AutocompleteField, MultiSelectField, createTextField } from '@roc/ui';
import { templatePlaceHolders } from 'libs/feature-communication/src/communication/utils/constants';
import { UserStore, useUserStore } from "@roc/feature-app-core";
import { MAX_FILE_SIZE } from 'libs/feature-communication/src/communication/utils/constants';
import { useStore } from '@roc/client-portal-shared/hooks';
import { BaseLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore';
import RichTextWithAttachments from '../../../utils/richTextWithAttachments';
import { HtmlContainer } from '../../leadDetails/htmlContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    contentContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    previewBox: {
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      },
      [theme.breakpoints.up('lg')]: {
        width: '75%',
      },
    },
    divider: {
      position: 'absolute',
      border: '1px solid grey',
      height: '95%',
      [theme.breakpoints.up('lg')]: {
        left: '53%',
      },
      [theme.breakpoints.down('md')]: {
        left: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    modalContainer: {
      position: 'relative'
    }
  })
);

export const SendEmailsChannel = observer(({ handleClose = () => { }, salesforceLeadStore, type, fromGrid = false, stepToEdit }: { handleClose, salesforceLeadStore: BaseLeadStore, type, fromGrid?, stepToEdit }) => {
  const { sendEmailsStore } = salesforceLeadStore;
  const { userStore: { userInformation } } = useUserStore();
  const userEmail = salesforceLeadStore.isSalesForce ? salesforceLeadStore.emailAddress : userInformation.username;
  const [attachments, setAttachments] = useState<File[]>([]);
  const [mockAttachments, setMockAttachments] = useState([]);
  const { globalStore, cadenceStore } = useStore();
  const { cadenceForm } = cadenceStore;

  const setupEmailEdition = () => {
    cadenceForm.onFieldChange('subject', stepToEdit.stepContent.subject || '');
    cadenceForm.onFieldChange('content', stepToEdit.stepContent.content || '');
    cadenceForm.onFieldChange('stepNumber', stepToEdit.stepNumber || '');
  }

  useEffect(() => {
    sendEmailsStore.initSentToOptions(type);
    if (stepToEdit?.stepContent) {
      setupEmailEdition();
    } else {
      cadenceForm.reset();
    }
  }, []);


  useEffect(() => {
    sendEmailsStore.mockAttachments = mockAttachments;
  }, [mockAttachments]);


  useEffect(() => {
      sendEmailsStore.updatePreview(userEmail, cadenceForm.form.fields.content.value,userInformation);
      setMockAttachments(sendEmailsStore.mockAttachments);
  }, [
    cadenceForm.form.fields.content.value,
    sendEmailsStore.selectedTemplateOption
  ]);

  const onFilesChange = (event): void => {
    const { files } = event.target as HTMLInputElement;
    if (files?.length) {
      addFiles(Array.from(files));
    }
  };

  const addFiles = (newFiles: File[]) => {
    const validFiles = newFiles.filter(
      ({ size }) => size < MAX_FILE_SIZE + 1
    );
    setAttachments(currentFiles => [...currentFiles, ...validFiles]);
  }

  const onEditorChange = (value: string) => {
    cadenceForm.onFieldChange('content', value);
  }


  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.modalContainer}>
      <Grid item style={{ flex: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Subject</Typography>
            {createTextField({
              label: '',
              fieldName: 'subject',
              testId: 'subject',
              store: cadenceForm,
            })}
          </Grid>


          <Grid item container className={classes.contentContainer}>
            <Typography variant="h6">Template</Typography>
            <Grid item xs={12}>
              <RichTextWithAttachments
                key={stepToEdit?.stepContent?.content || 'RichTextWithAttachments'}
                mockAttachments={mockAttachments}
                setMockAttachments={setMockAttachments}
                onChange={onEditorChange}
                value={stepToEdit?.stepContent?.content || cadenceForm.form.fields.content.value}
                attachments={attachments}
                onFilesChange={onFilesChange}
                setAttachments={setAttachments}
                reloadDependencies={[sendEmailsStore.selectedTemplateOption]}
                placeHolders={templatePlaceHolders}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {!!sendEmailsStore.previewHtml && (
        <>
          <div className={classes.divider}></div>
          <Grid item xs={12} md={6} className={classes.container}>
            <Box className={classes.previewBox}>
              <Box>
                <Box>
                  <Typography variant="h6">From: {userEmail}</Typography>
                </Box>
                <Box>
                  <Typography variant="h6">Subject: {cadenceForm.form.fields.subject.value}</Typography>
                </Box>
              </Box>
              <Box>
                <HtmlContainer html={sendEmailsStore.previewHtml} />
              </Box>
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  )
});